import request from '@/utils/request'

const tradeCreditLetterAttachmentApi = {
  trade_credit_letter_attachment_list: '/trade/credit_letter_attachment/',
  trade_credit_letter_attachment_create: '/trade/credit_letter_attachment/',
  trade_credit_letter_attachment_update: '/trade/credit_letter_attachment/',
  trade_credit_letter_attachment_delete: '/trade/credit_letter_attachment/'
}

/**
 * 列表
 */
export function credit_letter_attachment_list (parameter) {
  return request({
    url: tradeCreditLetterAttachmentApi.trade_credit_letter_attachment_list,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}
/**
 * 添加
 */
export function credit_letter_attachment_create (parameter) {
  return request({
    url: tradeCreditLetterAttachmentApi.trade_credit_letter_attachment_create,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 修改
 */
export function credit_letter_attachment_update (parameter, credit_letter_attachment_id) {
  return request({
    url: tradeCreditLetterAttachmentApi.trade_credit_letter_attachment_update + credit_letter_attachment_id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 删除
 */
export function credit_letter_attachment_delete (credit_letter_attachment_id) {
  return request({
    url: tradeCreditLetterAttachmentApi.trade_credit_letter_attachment_delete + credit_letter_attachment_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
